/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RemoveMetaMcpMemberSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RemoveMetaMcpMemberSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RemoveMetaMcpMemberSecurity = {
  option1?: RemoveMetaMcpMemberSecurityOption1 | undefined;
  option2?: RemoveMetaMcpMemberSecurityOption2 | undefined;
};

export type RemoveMetaMcpMemberRequest = {
  /**
   * The ID of the membership to remove
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RemoveMetaMcpMemberSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RemoveMetaMcpMemberSecurityOption1$outboundSchema: z.ZodMiniType<
  RemoveMetaMcpMemberSecurityOption1$Outbound,
  RemoveMetaMcpMemberSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function removeMetaMcpMemberSecurityOption1ToJSON(
  removeMetaMcpMemberSecurityOption1: RemoveMetaMcpMemberSecurityOption1,
): string {
  return JSON.stringify(
    RemoveMetaMcpMemberSecurityOption1$outboundSchema.parse(
      removeMetaMcpMemberSecurityOption1,
    ),
  );
}

/** @internal */
export type RemoveMetaMcpMemberSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RemoveMetaMcpMemberSecurityOption2$outboundSchema: z.ZodMiniType<
  RemoveMetaMcpMemberSecurityOption2$Outbound,
  RemoveMetaMcpMemberSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function removeMetaMcpMemberSecurityOption2ToJSON(
  removeMetaMcpMemberSecurityOption2: RemoveMetaMcpMemberSecurityOption2,
): string {
  return JSON.stringify(
    RemoveMetaMcpMemberSecurityOption2$outboundSchema.parse(
      removeMetaMcpMemberSecurityOption2,
    ),
  );
}

/** @internal */
export type RemoveMetaMcpMemberSecurity$Outbound = {
  Option1?: RemoveMetaMcpMemberSecurityOption1$Outbound | undefined;
  Option2?: RemoveMetaMcpMemberSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RemoveMetaMcpMemberSecurity$outboundSchema: z.ZodMiniType<
  RemoveMetaMcpMemberSecurity$Outbound,
  RemoveMetaMcpMemberSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RemoveMetaMcpMemberSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RemoveMetaMcpMemberSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function removeMetaMcpMemberSecurityToJSON(
  removeMetaMcpMemberSecurity: RemoveMetaMcpMemberSecurity,
): string {
  return JSON.stringify(
    RemoveMetaMcpMemberSecurity$outboundSchema.parse(
      removeMetaMcpMemberSecurity,
    ),
  );
}

/** @internal */
export type RemoveMetaMcpMemberRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RemoveMetaMcpMemberRequest$outboundSchema: z.ZodMiniType<
  RemoveMetaMcpMemberRequest$Outbound,
  RemoveMetaMcpMemberRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function removeMetaMcpMemberRequestToJSON(
  removeMetaMcpMemberRequest: RemoveMetaMcpMemberRequest,
): string {
  return JSON.stringify(
    RemoveMetaMcpMemberRequest$outboundSchema.parse(removeMetaMcpMemberRequest),
  );
}
